import { useEffect, useRef, useState } from "react";
import { API_URL } from "../api/api";
import { updateQuery } from "../state/slices/navigationSlice";
import { QUERY_KEY } from "../types/query.types";
import { useAppDispatch, useAppSelector } from "./reduxHooks";

export const useQueryValue = (key: QUERY_KEY) => {
  const dispatch = useAppDispatch();

  const reduxValue = useAppSelector((s) => s.navigation.query[key]);

  const [value, setValue] = useState(reduxValue);
  const debounceTimer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setValue(reduxValue);
  }, [reduxValue]);

  const update = (newValue: any) => {
    setValue(newValue);

    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      dispatch(updateQuery({ key, value: newValue }));
    }, 250);
  };

  useEffect(() => {
    return () => {
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
    };
  }, []);

  return {
    value,
    update
  }
};

export const useSearchUrl = () => {
  const { query } = useAppSelector(s => s.navigation);

  const urlWithFilter = (endpoint: string) => {
    const url = new URL(`${API_URL}${endpoint}`);

    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== "" && value !== null) {
        params.append(key, String(value));
      }
    });

    url.search = params.toString();
    return url.toString();
  };

  return { urlWithFilter };
};